import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span
          // style={{
          //   display: "flex",
          //   alignContent: "center",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   alignSelf: "center",
          //   marginBottom: "0.2rem",
          //   gap: "0rem",
          // }}
        >
          Created from ❤️ by Hafiz Saqlain in Pakistan
        </span>
        <span
          // style={{
          //   marginBottom: "2rem",
          // }}
        >
          hafizsaqlainmuntaba@gmail.com
        </span>
        <div className="f-icons">
          <a href="https://www.instagram.com/mujtabasaqlain3/">
            <Insta color="white" size={"3rem"} />
          </a>
          <a href="https://www.facebook.com/hafiz.saqlain.0207">
            <Facebook color="white" size={"3rem"} />
          </a>
          <a href="https://github.com/laladeveloper">
            <Gitub color="white" size={"3rem"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
